import React from 'react'

import { PermissionChecker } from '../../session'
import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import Container from '../../../components/structure/Container'
import Content from './Content'
import FormLoader from './_load/FormLoader'
import PageHeader from './PageHeader'
import Panel from '../../../packages/kiti/components/structure/Panel'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const FormReplyPage = ({ id, number }) => {
  return (
    <AbsolutePageTemplate>
      <PermissionChecker module="form" name="new">
        <FormLoader id={id}>
          <PageHeader />

          <Container maxWidth="64rem">
            <Separator weight={4} />
            <Panel>
              <Content initialNumber={parseInt(number)} />
            </Panel>
          </Container>
        </FormLoader>
      </PermissionChecker>
    </AbsolutePageTemplate>
  )
}

export default FormReplyPage
